import { Link, Text } from "@fluentui/react";

interface CatalogCollectionListProps {
  text: string;
  setFilterText: (filterText: string) => void;
}

export const CatalogCollectionSuggestion = ({
  text,
  setFilterText,
}: CatalogCollectionListProps) => {
  return (
    <Text styles={suggestionStyles}>
      Did you mean: "<Link onClick={() => setFilterText(text)}>{text}</Link>"?
    </Text>
  );
};

const suggestionStyles = {
  root: {
    fontStyle: "italic",
    fontSize: 15,
  },
};
